export const environment = {
    API_ENDPOINT_COT_SERVICE: 'https://api.si-cot.atenainformatica.it/cot-service/1.0.0',
    API_ENDPOINT_COT_ADMIN: 'https://api.si-cot.atenainformatica.it/cot-admin/1.0.0',
    API_ENDPOINT_CONFIGURATION: 'https://api.si-cot.atenainformatica.it/configuration-service/1.0.0',
    API_ENDPOINT_SOGGETTO_SERVICE: 'https://api.si-cot.atenainformatica.it/soggetto-service/1.0.0',
    API_ENDPOINT_NOTIFICATION: 'https://api.si-cot.atenainformatica.it/notification-service/1.0.0',
    redirect_url: 'https://app.si-cot.atenainformatica.it',
    client_id: 'RVXrlnxl_mVyVJd91OzPewsCIbca',
    issuer: 'https://auth.si-cot.atenainformatica.it/oauth2/token',
};
